import React from 'react';

export function CmsStyles({ styles }: { styles?: string }) {
  if (!styles) return null;
  return (
    // CMS-authored CSS for <style>; HTML sanitizers would corrupt stylesheet text.
    // oxlint-disable-next-line benzinga/no-unsanitized-innerhtml
    <style dangerouslySetInnerHTML={{ __html: styles }} />
  );
}
